import moment from 'moment';
import { formFullDate } from '../../../../utils';
import { Column, Row } from '../../../Basic/Blocks';
import { Text, TextGrey } from '../../../Basic/WrapsStyle';
import styles from './styles.module.scss';

const MarketProvidersDateUpdate = (providerData) => {
  return (
    <Column style={{ marginTop: '10px', minWidth: '600px' }}>
      <Row>
        <TextGrey className={styles.text_time}>Дата последнего обновления остатков</TextGrey>

        {providerData.status_stock === 'loading' ? (
          <Text>идет обновление</Text>
        ) : (
          <>
            <Text style={{ marginRight: '5px' }}>{formFullDate(providerData.stock?.date)}</Text>
            <TextGrey fontSize={14}>{moment(providerData.stock?.date).fromNow()}</TextGrey>
          </>
        )}
      </Row>
      <Row>
        <TextGrey className={styles.text_time}>Дата последнего пересчета цен</TextGrey>
        <Text style={{ marginRight: '5px' }}>{formFullDate(providerData.price?.date)}</Text>
        <TextGrey fontSize={14}>{moment(providerData.price?.date).fromNow()} </TextGrey>
      </Row>
    </Column>
  );
};

export default MarketProvidersDateUpdate;
